import { GLOBAL_ENV } from "@/modules/global-state/globalEnv";
import { isEmpty, toSafeInteger } from "lodash-es";
import { DateTime } from "luxon";

export const UNKNOWN_GIT_COMMIT_SHA = "unknown";

export const clientEnvBuildInfo = () => {
  const gitCommitSha = GLOBAL_ENV.GITHUB_SHA ?? UNKNOWN_GIT_COMMIT_SHA;
  const buildTimestamp = toSafeInteger(GLOBAL_ENV.BUILD_TIMESTAMP);

  const gitCommitValue = (() => {
    if (!gitCommitSha || isEmpty(gitCommitSha)) {
      return UNKNOWN_GIT_COMMIT_SHA;
    }

    return gitCommitSha;
  })();

  return {
    buildInfo: {
      gitCommitSha: gitCommitValue,
      buildTimestamp: DateTime.fromMillis(buildTimestamp),
    },
  };
};
